<template lang="pug">
v-app
  section
    header.d-flex.row.flex-row.align-items-end.mb-3
      .col-8
        router-link.button-previous.mr-2(to="/administracion/id/role")
          i.fas.fa-chevron-left
        h1.m-0.d-inline-block.align-middle
          i Editar Rol
      .col-4
        .h2.text-right.ad_text-grayLight.m-0
          i.text-capitalize
    section
      .d-flex.row.flex-row.align-items-start.mt-4
        .col-12
          .card.p-0.ad_bg-gray.rounded-xl
            .card-body
              form.d-flex.flex-row.flex-wrap
                .col-6.form-group.align-items-center.mb-4
                  label.col-3.pl-0.m-0 Nombre
                  input.col.form-control(type="text" v-model="name" maxlength='100' placeholder='ingresa nombre' title='ingresa tu nombre')
                .col-6.form-group.align-items-center.mb-4
                  label.col-3.pl-0.m-0 Descripción
                  textarea.form-control(v-model="description" maxlength='100' rows="3" placeholder='ingresa descripción' title='Descripción')
                  .col-auto.form-group.align-items-center.mb-0.pr-0
                //- .col-12
                //-   b-button(@click="addTriplet")
                //-     i.fas.icon-plus

            .card.p-0(v-for="(triplet, index) in triplets")
              .col.row.align-items-start
                label.font-weight-bold.col.pl-0.m-0 Viaje
                .col.px-0.ad_select
                  select(v-model='triplet.travel.value', @change='getSegments($event, index)')
                    option(:value="null" disabled) Selecciona Viaje
                    option(:value="travel.value" v-for="travel in todosMultiTravel", :key="travel.value") {{travel.label}}

              .col.row.align-items-start
                label.font-weight-bold.col.pl-0.m-0 Segmento
                .col.px-0.ad_select
                  select(v-model='triplet.segment.value', @change='getProducts($event, index)')
                    option(:value="null" disabled) Selecciona Segmento
                    option(:value="segment.value" v-for="segment in todosMultiSegment[index]", :key="segment.value") {{segment.label}}

              .col.row.align-items-start
                label.col.pl-0.m-0 Productos
                .col.px-0.ad_select
                  select(v-model='triplet.product.value')
                    option(:value="null" disabled) Selecciona Producto
                    option(:value="product.value" v-for="product in todosMultiProducts[index]", :key="product.value") {{product.label}}
              //- .col-12
              //-   b-button(@click="subsTriplet(index)")
              //-     i.fas.icon-minus

          .d-flex.flex-row.mt-5
            router-link.stepper-button.previous(to="/administracion/id/role")
              i.material-icons
              span Volver
            button.col-auto.stepper-button.next.ml-auto(@click="_updateRole()")
              span Actualizar
              i.material-icons


</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapActions } from 'vuex';
import { nullLiteralTypeAnnotation } from 'babel-types';
export default {
  name: 'AdministracionRoleEdit',
  components: {
     Multiselect
  },
  data () {
    return {
      role: null,
      name: null,
      description: null,
      goal: null,
      triplets: [],
      kpipercentage: null,
      selectedMultiRole: [],
      todosMultiRole: [],
      selectedMultiTravel: [],
      todosMultiTravel: [],
      selectedMultiSegment: [],
      todosMultiSegment: [],
      selectedMultiProducts: [],
      todosMultiProducts: []
    }
  },
  methods: {
    ...mapActions('user', [
      'getRoles'
    ]),
    ...mapActions('role', [
      'getRoleById', 'updateRole'
    ]),
    ...mapActions('travel', [
      'travelList', 'getTravelById'
    ]),
    ...mapActions('segment', [
      'ByTravelIds', 'segmentList', 'getSegmentById', 'ByTravelId'
    ]),
    ...mapActions('product', [
      'BySegmentIds', 'productList', 'getProductById', 'BySegmentId'
    ]),
    getValuesOfMultiSelect(valuesMultiSelect) {
      return valuesMultiSelect.map(values => values.value)
    },
    getItemsToMultiSelectLoad(items) {      
      return items.map(p => ({value: p.id, label: p.name}))
    },
    getSelectedAfterChangedParent(todos, oldSelectedItems) {
      return todos.filter(t => oldSelectedItems.map(o => o.value).includes(t.value))
    },
    getProductsToMultiSelectLoad(items) {      
      return items.map(p => ({value: p.id, label: `${p.name} (${p.segment.name}/${p.segment.travel.name})`}))
    },
    getSegmentsToMultiSelectLoad(items) {      
      return items.map(p => ({value: p.id, label: `${p.name} (${p.travel.name})`}))
    },
    setTripeltsToMultiSelectLoad(items) {
      return items.map(p => ({
        travel: {value: p.travel._id, label: p.travel.name}, 
        segment: {value: p.segment._id, label: `${p.segment.name} (${p.segment.travel.name})`}, 
        product: {value: p.product._id, label: `${p.product.name} (${p.product.segment.name}/${p.travel.name})`}
      }))
    },
    getTripletsFromMultiSelect(items) {
      return items.map((p) => ({
        travel: p.travel.value,
        segment: p.segment.value,
        product: p.product.value
      }))
    },
    setRoleProps() {      
      const vm = this
      let t = (vm.role.triplets.length > 0) ? vm.role.triplets : [{travel: null, segment: null, product: null}]
      try {
        vm.name = vm.role.name
        vm.description = vm.role.description
        vm.triplets = vm.setTripeltsToMultiSelectLoad(t)
      } catch (e) {
        console.info(e)
      }
    },
    getRoleFromProps() {
      const vm = this
      return {
        id: vm.role._id,
        name: vm.name,
        description: vm.description,
        triplets: vm.getTripletsFromMultiSelect(vm.triplets)
      }
    },
    loadDetail(id) {
      const vm = this
      const loading = vm.$toast.loading('Cargando Detalle...')      
      vm.getRoleById(id).then((role) => {
        vm.role = vm.$store.getters['role/getRole']
        vm.getTriplets().then(() => {
          vm.setRoleProps()
          vm.loadTravels()                    
          vm.loadListForTriplet()
          loading.hide()
        }, (error) => {
          loading.hide()
          vm.notify(true, error)
        })        
      }).catch(error => {
        loading.hide()
        vm.notify(true, error)        
      })
    },
    loadTravels() {
      const vm = this
      vm.travelList({}).then(response => {
        vm.todosMultiTravel = vm.getItemsToMultiSelectLoad(response)
      })
    },
    loadSegments(index) {
      const vm = this
      vm.segmentList({}).then(response => {
        vm.todosMultiSegment[index] = vm.getSegmentsToMultiSelectLoad(response)
      })
    },
    loadListForTriplet() {
      const vm = this
      let loadInfo = function (trip, index) {
        return new Promise((resolve, reject) => {
          vm.ByTravelId({travel: trip.travel.value}).then((response) => {      
            vm.todosMultiSegment[index] = vm.getSegmentsToMultiSelectLoad(response)
            vm.BySegmentId({segment: trip.segment.value}).then(response => {
              vm.todosMultiProducts[index] = vm.getProductsToMultiSelectLoad(response)
              resolve() 
            }, (error) => {
              console.info(error)
              reject(error)
            })        
          }, (error) => {
            console.info(error)
            reject(error)
          })
        })
      }        
      
      let actions = vm.triplets.map(loadInfo)
      let results = Promise.all(actions)
      results.then(() => {
        vm.$forceUpdate();
      }, (error) => {
        console.info(error)
        vm.notify(true, error)
      })
    },
    getSegments($event, index) {
      const vm = this
      if (vm.triplets[index].travel.value !== null) {
        vm.ByTravelId({travel: vm.triplets[index].travel.value}).then((response) => {          
          vm.todosMultiSegment[index] = vm.getSegmentsToMultiSelectLoad(response)
          vm.$forceUpdate();        
        }, (error) => {
          vm.notify(true, error)
        })
      }
    },
    getProducts($event, index) {
      const vm = this
      vm.BySegmentId({segment: vm.triplets[index].segment.value}).then(response => {
        vm.todosMultiProducts[index] = vm.getProductsToMultiSelectLoad(response)
        vm.$forceUpdate();
      }, (error) => {
        vm.notify(error)
      })
    },
    notify(error = true, message) {
      const vm = this
      vm.$notify({
          type: error ? 'danger' : 'success',
          title: 'Notificación',
          content: message,
          closeable: true,
          duration: 5000
        })
    },
    _updateRole() {
      const vm = this
      const loading = vm.$toast.loading('Guardando...')
      const data = vm.getRoleFromProps()
      if (vm.validate(data)) {                
        vm.updateRole(data).then(result => {
          if (!result.success) {
            loading.hide()
            vm.notify(true, result.message)
          } else {
            loading.hide()
            vm.notify(false, 'Rol actualizado')
          }
        }).catch(error => {
          loading.hide()
          vm.notify(true, error.payload.message)
        })
      } else {
        loading.hide()
      }
    },
    isValidInput(input) {
      return input !== undefined && input !== null && input.length > 0
    },
    isValidInputPer(input) {
      return input >= 0 && input <= 100
    },
    validate(data) {
      const vm = this
      let valid = true
      let missing = ''
      
      if (!vm.isValidInput(data.name)) {
        missing = 'Debe completar el campo nombre'
        valid = false
      } else if (!vm.isValidInput(data.description)) {
        missing = 'Debe completar el campo descripción'
        valid = false
      }

      for (let t of data.triplets) {
        if (t.travel == null || t.segment == null || t.product == null) {
          missing = 'Debe completar los campos de viaje, segmento y producto'
          valid = false;
          break;
        }
      }

      if (valid) {
        return true
      } else {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: missing,
          closeable: true,
          duration: 5000
        })
        return false
      }
    },
    getTriplets() {
      return new Promise((res, rej) => {
        const vm = this      
        let findTriplets = function(trip, index) {
          return new Promise((resolve, reject) => {
            vm.getTravelById(trip.travel).then((travel) => {  
              vm.role.triplets[index].travel = travel              
              vm.getSegmentById(trip.segment).then((segment) => {              
                vm.role.triplets[index].segment = segment                              
                vm.getProductById(trip.product).then((product) => {                
                  vm.role.triplets[index].product = product
                  resolve()
                }, (error) => {
                  reject(error)
                })
              }, (error) => {
                reject(error)
              })
            }, (error) => {
              reject(error)
            })
          })
        }

        let actions = vm.role.triplets.map(findTriplets)
        let results = Promise.all(actions)
        results.then(() => {
          res()
        }, (error) => {
          rej(error)
        })
      })            
    },
    addTriplet() {
      const vm = this
      vm.triplets.push({
        travel: {value: null, label: null}, 
        segment: {value: null, label: null}, 
        product: {value: null, label: null}
      })
    },
    subsTriplet(index) {
      const vm = this
      vm.triplets.splice(index, 1)
    }
  },
  mounted() {
    const vm = this;
    vm.loadDetail(this.$route.params.id)
    this.$emit('can-continue', { value: true })
  }
}
</script>

<style lang="css" scoped></style>


// WEBPACK FOOTER //
// src/views/administracion-role-edit.vue